import Helmet from "react-helmet";
import './style.scss';
import { useNavigate } from "react-router-dom";

function NotFound(props: {message?: string}) {
    const navigate = useNavigate();

    return (
        <div id="content">
            <Helmet>
                <title>Page Not Found</title>
                <meta name="description" content="Page Not Found"/>
            </Helmet>
            {/* Heading */}
            <div className='not-found'>
                <h2>Page Not Found</h2>
                <p>{props.message || 'or Optional Feature has not been Enabled'}</p>
                {props.message ? <span onClick={() => window.location.reload()}>Try Again</span> : <span onClick={() => navigate('/')}>Return to home page</span>}
            </div>
        </div>
    );
}


export default NotFound;
